import Vue from 'vue';
export default{
  namespaced: true,
  state:{
    orderPeople:null
  },
  getters:{
    
  },
  mutations:{
    setOrderPeople(state,data){
      state.orderPeople=data
    },
    
  },
  actions:{
    SET_ORDER_PEOPLE ({ commit },data) {
      commit('setOrderPeople',data)
    }
  }
}